import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { PrivacyCookiePolicyFooter } from "../../components/PrivacyCookiePolicyFooter";
import { PrivacyCookiePolicyMenu } from "../../components/PrivacyCookiePolicyMenu";
import "./style.css";
import womanExclamation from "./womanExclamation.svg";

const fm = getFormattedMessageWithScope("views.NotFound");

export const NotFound = () => {
    return (
        <>
            <div className="v-NotFound-PrivacyCookiePolicyMenu-container">
                <PrivacyCookiePolicyMenu />
            </div>
            <div className="v-NotFound-container">
                <img src={womanExclamation} alt="error" />
                <p className="v-NotFound-error">{fm("notFoundError")}</p>
                <PrivacyCookiePolicyFooter />
            </div>
        </>
    );
};
